/*
 * @Author: Gaho
 * @Date: 2024-01-15 16:15:06
 * @LastEditors: Gaho
 * @LastEditTime: 2024-01-26 16:51:52
 */
import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export const useLimbo = (rootPath = 'games') => {
    const EMIT_LIMBO_JOIN = (
        data: {},
        callback: any,
    ) => {
        socket.emit(`${rootPath}.limbo.join`, data, callback);
    };
    
    const EMIT_LIMBO_BET = (data: any, callback: any) => {
        const amountMemory = useAmountMemoryStore();
        // socket.emit(`${rootPath}.limbo.bet`, data, callback);
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return asyncEmit<{
            response
        }>( `${rootPath}.limbo.bet`, data);
    }

    return {
        EMIT_LIMBO_JOIN,
        EMIT_LIMBO_BET
    }
}